import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/** Edge-to-edge WebView + status bar icons that match the active theme. */
export async function syncNativeStatusBar(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await StatusBar.setOverlaysWebView({ overlay: true });
  } catch (error) {
    console.warn('[StatusBar] setOverlaysWebView failed:', error);
  }

  const isDark =
    typeof document !== 'undefined' &&
    document.documentElement.classList.contains('dark');

  try {
    await StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light });
  } catch (error) {
    console.warn('[StatusBar] setStyle failed:', error);
  }
}
